import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import { AuthProvider } from "./context/AuthContext";
import { PatientsProvider } from "./context/PatientsContext";
import { UsersProvider } from "./context/UsersContext";
import { AppointmentsProvider } from "./context/AppointmentsContext";
import { TratamenteProvider } from "./context/TratamenteContext";
import { WorkingHoursProvider } from "./context/WorkingHoursContext";
import { ServicesProvider } from "./context/ServicesContext";
import { PresetsProvider } from "./context/PresetsContext";
import { UiPreferencesProvider } from "./context/UiPreferencesContext";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <UiPreferencesProvider>
          <WorkingHoursProvider>
            <ServicesProvider>
              <PresetsProvider>
                <UsersProvider>
                  {/* ✅ mutat deasupra */}
                  <PatientsProvider>
                    <AppointmentsProvider>
                      <TratamenteProvider>
                        <App />
                      </TratamenteProvider>
                    </AppointmentsProvider>
                  </PatientsProvider>
                </UsersProvider>
              </PresetsProvider>
            </ServicesProvider>
          </WorkingHoursProvider>
        </UiPreferencesProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
